import { useQuery } from '@apollo/client';
import type { UseUserFetch } from '@openx/components-administration/lib/utils/context/UserHookTypes';
import { GetUserDocument } from '../../../../graphql/query/users/GetUser.generated';

export const useUserFetch: UseUserFetch = userId => {
  const {
    data: { user_by_pk: user } = {},
    loading,
    refetch,
  } = useQuery(GetUserDocument, { skip: !userId, variables: { id: userId } });

  return {
    loading,
    user,
    refetch,
  };
};
